<template>
  <v-container>
    <v-row justify="center">
      <v-col md="6" sm="7" xs="12">
        <v-card>
          <v-form ref="form">
            <v-row align="center" justify="space-between" no-gutters>
                <v-card-title>
                  Login
                </v-card-title>
                <v-btn
                  data-cy="sign-up-btn"
                  style="margin-right:15px"
                  plain
                  small
                  text
                  primary
                  outlined
                  :to="{name: 'sign-up-form'}"
                  
                >
                  Sign Up
                </v-btn>
            </v-row>
            <v-card-text>
              <v-text-field
                v-model="loginData.username"
                data-cy="login-text-username"
                :rules="[rules.required]"
                label="Username"
              />
              <v-text-field
                v-model="loginData.password"
                data-cy="login-text-password"
                :rules="[rules.required]"
                label="Password"
                type="password"
                v-on:keyup.enter="submit"
              />
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-btn
                    data-cy="login-btn-submit"
                    color="primary"
                    @click="submit"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-row justify="end">
                <v-col cols="auto">
                  <p class="forgot"><a :href="`/password-reset-email`">Forgot Password?</a></p>
                </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { login, isLoggedIn } from '../services/users';

export default {
  data() {
    return {
      loginData: {
        username: '',
        password: '',
      },
      rules: {
        required: (value) => !!value || 'Required.',
        counter: (value) => value.length <= 20 || 'Max 20 characters',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      try {
        const { data } = await login(this.loginData);
      }
      catch(err){
        this.$emit('snackbar', { text: 'Username/Password combination is incorrect.', color: 'red' });
        return;
      }
      
      const redirectPath = this.$route.query.redirect;
      if (redirectPath) {
        this.$router.push({ path: decodeURIComponent(redirectPath) });
      } else {
        this.$router.push({ name: 'jobs' });
      }
      console.log(data);
      const response = await isLoggedIn();
      console.log(response?.data);
    },
  },
};
</script>

<style>
  .forgot {
    margin: 10px;
  }
</style>
